<mat-toolbar class="p-0 mat-elevation-z1">

  <mat-progress-bar *ngIf="showLoadingBar" class="loading-bar" color="accent" mode="indeterminate"></mat-progress-bar>

  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

      <button mat-icon-button class="toggle-button-navbar mat-icon-button" *ngIf="!noNav" (click)="toggleSidebarOpened('navbar')" fxHide.gt-md matTooltip="Toggle Navbar" aria-label="Toggle Navbar">
        <mat-icon>menu</mat-icon>
      </button>

      <div class="toolbar-separator" fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNav">
        <div class="logo ml-16">
          <img class="logo-icon" src="assets/images/tfl-logo.jpg" alt="InCase365 TfL Logo">
        </div>
      </div>

    </div>

    <div class="" fxFlex="1 1" fxLayout="row" fxLayoutAlign="start center" *showAuthed=false>
      &nbsp;{{this.appName}}
    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="start center">

      <button id="btnLogin" mat-button class="mat-button log-in-button" aria-label="Log in" (click)="logIn()" *showAuthed=false>
        <div fxLayout="row" fxLayoutAlign="center center">
          <img class="avatar" src="assets/images/avatars/profile.jpg" alt="User Profile">
          <span class="username mr-12" fxHide fxShow.gt-sm>Log in</span>
        </div>
      </button>

      <div *ngIf="showStopwatch" class="stopwatch">
        <div class="time" [ngClass]="{'blink':paused && (!stopped)}">
          <div>{{hours}}</div>
          <div>hrs</div>
          <div [ngClass]="{'blink':!(paused || stopped)}">:</div>
          <div>{{minutes}}</div>
          <div>mins</div>
        </div>
        <div class="playbackbuttons">
          <button *ngIf="paused || stopped" mat-icon-button type="button mat-icon-button" class="playback mat-elevation-z1" matTooltip="Start" aria-label="Start recording time" (click)="resume($event)"><mat-icon>play_arrow</mat-icon></button>
          <button *ngIf="!(paused || stopped)" mat-icon-button type="button mat-icon-button" class="playback mat-elevation-z1" matTooltip="Pause" aria-label="Pause recording time" (click)="pause($event)"><mat-icon>pause</mat-icon></button>
          <button *ngIf="!stopped" mat-icon-button type="button mat-icon-button" class="playback mat-elevation-z1" matTooltip="Stop" aria-label="Stop recording time" (click)="stop($event)"><mat-icon class="stop">stop</mat-icon></button>
        </div>
      </div>
      <div *ngIf="showStopwatch" class="toolbar-separator"></div>
      
      <button id="btnMyAccount" mat-button [matMenuTriggerFor]="userMenu" class="user-button" *showAuthed=true>
        <div fxLayout="row" fxLayoutAlign="center center">
          <img class="avatar" src="assets/images/avatars/profile.jpg" alt="User Profile">
          <span id="txtUserName" class="username mr-12" fxHide fxShow.gt-sm>{{userName}}</span>
          <mat-icon class="s-16" fxHide.xs>keyboard_arrow_down</mat-icon>
        </div>
      </button>

      <mat-menu #userMenu="matMenu" [overlapTrigger]="false">

        <button id="btnUserProfile" mat-menu-item (click)="showUserProfile()" >
          <mat-icon>account_circle</mat-icon>
          <span>My Profile</span>
        </button>

        <button id="btnLogout" mat-menu-item class="" (click)="logOut()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>

      </mat-menu>

      <div class="toolbar-separator" *showAuthed=true></div>

      <fuse-search-bar (onInput)="search($event)" (keyup.enter)="doSearch();" *showAuthed=true #searchbar matTooltip='Search'></fuse-search-bar>

      <div class="toolbar-separator" *showAuthed=true></div>

      <button mat-button class="mat-button feedback-button" #feedbackButton aria-label="Feedback" *showAuthed=true matTooltip="Leave feedback" (click)="feedbackButton._elementRef.nativeElement.blur(); showFeedbackForm()">
        <mat-icon class="icon">feedback</mat-icon>
      </button>

      <!--
      <div class="toolbar-separator" *showAuthed=true></div>

      <button mat-button class="mat-button settings-button" aria-label="Settings" *showAuthed=true matTooltip="Leave feedback">
        <mat-icon class="icon">settings</mat-icon>
      </button>

      <div class="toolbar-separator" *showAuthed=true></div>

      <button mat-button class="mat-button quick-panel-toggle-button" fuseMatSidenavToggler="quick-panel" aria-label="Toggle quick panel" *showAuthed=true>
        <mat-icon class="icon">list</mat-icon>
      </button> -->
    </div>
  </div>
</mat-toolbar>
